export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/softDeleteExamForm`,
                method: 'POST',
                body: payload
            };
        },
    })
